import React from 'react';
import { Link } from 'react-router-dom';
import './Laboratory.css';

function Laboratory() {
  return (
    <div className="laboratory-page">
      {/* 页面横幅 */}
      <div className="page-banner">
        <div className="banner-content">
          <h1>省市重点实验室</h1>
          <p>中药材产业创新与可持续发展研究中心</p>
        </div>
      </div>

      {/* 主要内容区域 */}
      <div className="page-container">
        {/* 介绍部分 */}
        <section className="intro-section">
          <h2>实验室概况</h2>
          <p className="intro-text">
            以中部道地药材与特色药用植物为核心，研究其生态特性与质量形成机制，
            通过基因挖掘和分子育种创新种质，建立标准化生产体系，开发抗炎活性成分并推动产业化，
            减少对野生资源依赖，实现中药材产业提质增效与可持续发展。
          </p>
        </section>

        {/* 研究方向 */}
        <section className="research-section">
          <h2>研究方向</h2>
          <div className="research-grid">
            <div className="research-item">
              <div className="research-image">
                {/* 预留图片位置 */}
                <div className="image-placeholder">研究图片1</div>
              </div>
              <div className="research-content">
                <h3>药用植物资源与育种</h3>
                <p>
                  通过现代分子生物学技术，开展药用植物种质资源收集、保存和创新利用。
                  运用基因组学、转录组学等技术，挖掘优良基因资源，培育高产、优质、
                  抗逆性强的药用植物新品种。
                </p>
                <ul className="research-points">
                  <li>种质资源库建设</li>
                  <li>分子标记辅助育种</li>
                  <li>基因编辑技术应用</li>
                  <li>新品种选育与推广</li>
                </ul>
              </div>
            </div>

            <div className="research-item reverse">
              <div className="research-content">
                <h3>活性成分研究与开发</h3>
                <p>
                  系统研究中药材有效成分的提取、分离、纯化技术，阐明药效物质基础。
                  开展药理活性筛选，发现具有抗炎、抗肿瘤、抗氧化等生物活性的天然产物，
                  为新药开发提供先导化合物。
                </p>
                <ul className="research-points">
                  <li>有效成分分离纯化</li>
                  <li>结构鉴定与修饰</li>
                  <li>药理活性评价</li>
                  <li>作用机制研究</li>
                </ul>
              </div>
              <div className="research-image">
                {/* 预留图片位置 */}
                <div className="image-placeholder">研究图片2</div>
              </div>
            </div>

            <div className="research-item">
              <div className="research-image">
                {/* 预留图片位置 */}
                <div className="image-placeholder">研究图片3</div>
              </div>
              <div className="research-content">
                <h3>标准化生产技术体系</h3>
                <p>
                  建立从种植、采收、加工到储存的全程质量控制体系。
                  制定药材生产技术规程和质量标准，推进中药材规范化、标准化生产，
                  确保药材质量稳定可控。
                </p>
                <ul className="research-points">
                  <li>GAP种植技术规范</li>
                  <li>采收加工标准化</li>
                  <li>质量追溯体系建设</li>
                  <li>储存保鲜技术研究</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* 科研成果 */}
        <section className="achievements-section">
          <h2>科研成果</h2>
          <div className="achievements-grid">
            <div className="achievement-card">
              <div className="achievement-icon">🏆</div>
              <h3>获奖成果</h3>
              <p>省部级科技进步奖5项</p>
              <p>市级科技成果奖8项</p>
            </div>
            <div className="achievement-card">
              <div className="achievement-icon">📚</div>
              <h3>论文专著</h3>
              <p>SCI论文120余篇</p>
              <p>专著教材10部</p>
            </div>
            <div className="achievement-card">
              <div className="achievement-icon">🔬</div>
              <h3>专利技术</h3>
              <p>发明专利35项</p>
              <p>实用新型专利20项</p>
            </div>
            <div className="achievement-card">
              <div className="achievement-icon">🌱</div>
              <h3>新品种</h3>
              <p>培育新品种8个</p>
              <p>推广面积10万亩</p>
            </div>
          </div>
        </section>

        {/* 实验设备 */}
        <section className="equipment-section">
          <h2>仪器设备</h2>
          <div className="equipment-list">
            <div className="equipment-category">
              <h3>分析检测设备</h3>
              <ul>
                <li>高效液相色谱仪（HPLC）</li>
                <li>气相色谱-质谱联用仪（GC-MS）</li>
                <li>液相色谱-质谱联用仪（LC-MS）</li>
                <li>核磁共振波谱仪（NMR）</li>
              </ul>
            </div>
            <div className="equipment-category">
              <h3>生物技术设备</h3>
              <ul>
                <li>实时荧光定量PCR仪</li>
                <li>高通量测序平台</li>
                <li>流式细胞仪</li>
                <li>激光共聚焦显微镜</li>
              </ul>
            </div>
            <div className="equipment-category">
              <h3>培养设备</h3>
              <ul>
                <li>植物组织培养室</li>
                <li>人工气候室</li>
                <li>超净工作台</li>
                <li>恒温培养箱</li>
              </ul>
            </div>
          </div>
        </section>

        {/* 合作交流 */}
        <section className="cooperation-section">
          <h2>合作交流</h2>
          <div className="cooperation-content">
            <p>
              实验室与中国科学院、中国中医科学院等多家科研院所建立了长期合作关系，
              与多家制药企业开展产学研合作，共同推进中药材产业化发展。
              定期举办学术研讨会，邀请国内外专家学者交流访问。
            </p>
            <div className="partners-grid">
              <div className="partner-item">合作院所 10+</div>
              <div className="partner-item">企业合作 20+</div>
              <div className="partner-item">国际交流 15+</div>
              <div className="partner-item">年度项目 30+</div>
            </div>
          </div>
        </section>

        {/* 返回按钮 */}
        <div className="back-link">
          <Link to="/" className="btn-back">返回首页</Link>
        </div>
      </div>
    </div>
  );
}

export default Laboratory;